import React, { useEffect, useState } from "react";
// import { MDBDataTable } from "mdbreact"
import { Row, Col, Card, CardBody, CardTitle, CardSubtitle, Button } from "reactstrap"
// import "./datatables.scss";
import '../Icons/IconFontawesome';

import Utils from '../Utility';
import { post, get } from "../../helpers/api_helper";
import DeleteModal from './DeleteModal';
import DataTable from 'react-data-table-component';
// import './Card.scss';

const Table = (props) => {
  const { user, role, currentUser, from, setCurrentUser } = props;
  const [columns, setColumns] = useState([]);
  const [data, setData] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);

  useEffect(() => {
    if (user) {
      getCompanies();
    }
  }, [user]);

  const getCompanies = () => {
    get("/comp/list", { token: user?.token })
      .then(json => {
        // console.log('response from get project list', json);
        if (json?.statusCode == 200) {
          setData(json?.data);
        }
      })
      .catch(error => {
        console.log('error while getting project list', error);
      })
  }

  useEffect(() => {
    setColumns([
      {
        name: 'Logo',
        cell: (row) => <>
          <img style={{width:50, height:'auto'}} src={row?.logo} />
        </>
      },
      {
        name: 'Title',
        cell: (row) => <>
          <span title={row.title}>{row.title}</span>
        </>
      },
      {
        name: 'Company Id',
        selector: row => row.compId,
      },
      // {
      //   name: 'Code',
      //   selector: row => row.code,
      // },
      {
        name: 'Type',
        selector: row => row.type,
      },
      // {
      //   name: 'Strength',
      //   selector: row => row.strength,
      // },
      // {
      //   name: 'Working Day',
      //   selector: row => row.workingDay,
      // },
      // {
      //   name: 'Description',
      //   cell: (row) => <>
      //     <span title={row?.desc}>{row.desc.length>55 ? row.desc.slice(0, 55)+"..." : row.desc}</span>
      //   </>,
      // },
      // {
      //   name: 'Created At',
      //   selector: row => row.createdAt,
      // },
      {
        cell: (row) => <>
          <Button onClick={() => handleUpdateStatus(row, 'course')}
            title={row?.isActive ? "Inactive" : "Active"}
            style={{ backgroundColor: !row.isActive ? 'red' : 'green', marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}>
            <span className="text-white" style={{}}>
              {!row?.isActive ? 'Inactive' : 'Active'}
            </span>
          </Button>
        </>,
        name: 'Status',
        ignoreRowClick: true,
      },
      {
        cell: (row) => <>
          <Button onClick={() => props?.history.push(`/company/` + row?._id)}
            title={"View"}
            style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className="mdi mdi-eye" style={{ fontSize: 20 }}></span></Button>
          {from != 'Dashboard' &&
            <>
              <Button onClick={() => handleUpdateProj(row)}
                title={"Edit"}
                style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className="mdi mdi-pencil" style={{ fontSize: 20 }}></span></Button>
              <Button onClick={() => handleDeleteProj(row)}
                title={"Delete"}
                style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className="mdi mdi-delete" style={{ fontSize: 20 }}></span></Button>
            </>
          }
        </>,
        name: 'Action',
        ignoreRowClick: true,
        // allowOverflow: true,
        // button: true,
      },
    ])
  }, [data]);

  const handleUpdateProj = (proj) => {
    console.log('updating proj', proj);
    props?.setCurrentUser(proj);
    props.add(true);
  }

  const handleUpdateStatus = (item, metaType) => {
    console.log('updating proj', item);
    setCurrentUser({ ...item, metaType, actionType: 'Status' });
    setDeleteModal(true);
  }

  const handleDeleteProj = (proj) => {
    console.log('updating proj', proj);
    props?.setCurrentUser(proj);
    setDeleteModal(true);
  }

  const onDelete = () => {
    console.log('deleted', currentUser);
    post("/comp/delete", { companyId: currentUser?._id, token: user?.token })
      .then(json => {
        console.log('response from delete user', json);
        if (json.statusCode == 200) {
          getCompanies();
          setDeleteModal(false);
          props?.setCurrentUser(null);
        }
      })
      .catch(error => {
        console.error('error while deleting user', error);
      })
  }

  return (
    <React.Fragment>
      <div className="">
        <Row>
          <DeleteModal
            show={deleteModal}
            onDeleteClick={() => onDelete()}
            onCloseClick={() => setDeleteModal(false)}
          />
          <Col className="col-12">
            <Card>
              <CardBody>
                {from != 'Dashboard' &&
                  <div className="d-flex" style={{ marginLeft: 'auto', marginBottom: 30 }}>
                    <div>
                      <CardTitle className="h4">{props.role}</CardTitle>
                      <CardSubtitle className="mb-3">
                        {role} you have added before, All the <code>Opportunities</code> will be added according to Companies.
                      </CardSubtitle>
                    </div>
                    <div className="text-center" style={{ marginLeft: 'auto' }}>
                      <Button style={{ backgroundColor: Utils.themeColor }} onClick={() => props?.add(true)}>
                        Add
                      </Button>
                    </div>
                  </div>
                }

                <DataTable
                  columns={columns}
                  data={data}
                  pagination
                  customStyles={{
                    headCells: {
                      style: {
                        color: 'black',
                        fontWeight: 'bold',
                        fontSize: 15,
                        maxWidth: 80
                      },
                    },
                    cells: {
                      style: {
                        maxWidth: 50
                      }
                    }
                  }}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>

    </React.Fragment>
  )
}

export default Table;
